import React from 'react';
import pt from 'prop-types';

import AppReviewComment from './comment';

export default function AppReviewDeleteMessage({ comment }) {
  return (
    <>
      <p>
        Are you sure you want to delete this comment? This cannot be undone.
      </p>
      <div className="review-comments--preview">
        <AppReviewComment comment={comment} />
      </div>
    </>
  );
}

AppReviewDeleteMessage.propTypes = {
  comment: pt.object.isRequired,
};
